import { css } from '@emotion/react';

import { Spacing } from 'chatie-design-system';

import Frame from './Frame';

const storySkeletonCSS = css`
  padding: ${Spacing.small}px ${Spacing.medium}px;
  display: grid;
  box-sizing: content-box;
  height: 72px;
  grid-template-columns: 96px 1fr 1fr;
  grid-template-rows: repeat(3, 1fr);
  gap: ${Spacing.medium}px;

  div:nth-of-type(1) {
    grid-row: 1 / 4;
  }

  div:nth-of-type(2) {
    grid-column: 2 / 3;
    grid-row: 1 / 2;
  }

  div:nth-of-type(3) {
    grid-column: 2 / 4;
    grid-row: 2 / 3;
  }

  div:nth-of-type(4) {
    grid-column: 2 / 3;
    grid-row: 3 / 4;
  }
`;

const StorySkeleton = () => {
  return (
    <div css={storySkeletonCSS}>
      <Frame />
      <Frame />
      <Frame />
      <Frame />
    </div>
  );
};

export default StorySkeleton;
